import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { CustomerActivityEventHydration } from './customer-activity-event-hydration.dto';

/**
 * A customer activity event with hydrated related records.
 */
export class CustomerActivityEventDto extends ActivityEventDto {
  hydrated?: CustomerActivityEventHydration;
}
